import React, { useState } from 'react';
import { Modal, Input } from 'antd';
import { Button } from '../../../components/ui';
import { useForm, Controller } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import * as Joi from 'joi';
import { useCreateDomainMonitoring } from '../../../mutation/monitoringDomain';

const schema = Joi.object().keys({
  domain: Joi.string().regex(
    /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/,
  ),
});

export default function CreateMonitoringDomainButton() {
  const [showModal, setShowModal] = useState(false);
  const { isLoading, mutateAsync } = useCreateDomainMonitoring();
  const { control, handleSubmit, reset } = useForm({
    mode: 'onChange',
    defaultValues: {
      domain: '',
    },
    resolver: joiResolver(schema),
  });
  return (
    <>
      <Button
        loading={isLoading}
        type="button"
        onClick={() => setShowModal(true)}
      >
        Add Domain
      </Button>
      <Modal
        title="Create new Monitoring Domain"
        visible={showModal}
        onCancel={() => setShowModal(false)}
        onOk={handleSubmit(async values => {
          setShowModal(false);
          await mutateAsync(values);
          reset();
        })}
      >
        <Controller
          control={control}
          name="domain"
          render={({ field: { value, onChange, onBlur } }) => {
            return (
              <div style={{ marginTop: 10 }}>
                <p className="input-name">Domain</p>
                <Input
                  placeholder="turing.com"
                  value={value}
                  onBlur={onBlur}
                  onChange={onChange}
                />
              </div>
            );
          }}
        />
      </Modal>
    </>
  );
}
